import { ApiService } from '../../../services/api_service';
import * as classNames from 'classnames';
import { formStyle, WFormData } from '../../../core/forms/WFormFramework';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import style from './DialogCO2ServiceMail.less';
import { WActionButton } from '../../../core/elements/WActionButton';

export interface DialogCO2ServiceMailProps {
    data: any;
    entity: any;
    values: any;
    onClose: () => void;
}

export interface DialogCO2ServiceMailState {
    data: any;
}

export class DialogCO2ServiceMail extends React.Component<DialogCO2ServiceMailProps, DialogCO2ServiceMailState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: {}
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private absender: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).email || null;
    private name: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name || null;

    private empfaenger: string = 'service@energie-tool.de';
    private FormData: any = new WFormData();
    private subject: string = `Emissionsfaktor${(this.props.entity || {}).entity === IDs.ENT_CO2_SCOPE3_ABFALL
        ? ' [Abfall - Kategorie]'
        : (this.props.entity || {}).entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF
            ? ' [Gütereinkauf - Art]'
            : ''}`;

    getValue(value: any): any {
        return typeof value !== 'undefined' && value !== null && !isNaN(+value) ? +value : null;
    }

    onChange(event: any): void {
        const name: string = event.name || null;
        const values: any = {
            ...this.state.data,
            [name]: typeof event.value !== 'undefined' ? event.value : null
        };
        this.setState({ data: values });
    }

    render(): JSX.Element {
        return (
            <div className={classNames(formStyle.sidebysideComplexGreen, style.wrapper)}>
                {this.renderText()}
                {this.renderForm()}
                {this.renderButtons()}
            </div>
        );
    }

    renderButtons(): JSX.Element {
        const disabled: boolean = this.renderValidation('name') !== null;

        return (
            <div className={style.buttons}>
                <WActionButton
                    label='Versenden'
                    insideText='Versenden'
                    styleProps={disabled
                        ? { backgroundColor: 'lightgray', cursor: 'not-allowed' }
                        : { color: 'white', backgroundColor: '#00b050' }
                    }
                    key='send'
                    disabled={disabled}
                    action='MAIL'
                    onAction={() => this.sendMail()}
                />
                <WActionButton
                    label='Schließen'
                    insideText='Schließen'
                    styleProps={{ color: 'white', backgroundColor: '#00b050' }}
                    key='close'
                    action='delete'
                    onAction={this.props.onClose}
                />
            </div>
        );
    }

    renderForm(): Array<JSX.Element> {
        const values: any = this.state.data || {};
        this.FormData.setAllValues({
            emissionsfaktor: this.getValue(values.emissionsfaktor),
            name: (values.name || null) && values.name.toString().length
                ? values.name
                : null,
            quelle: (values.quelle || null) && values.quelle.toString().length
                ? values.quelle
                : null
        });

        return [
            <div key='name' className={style.fields}>
                <div>
                    <label htmlFor='name'>
                        Name / Verwendungszweck
                    </label>
                </div>
                <div>
                    <input
                        id='name'
                        name='name'
                        type='text'
                        value={values.name}
                        required
                        onChange={(event: any) => this.onChange(event.target)}
                    />
                    {this.renderValidation('name')}
                </div>
            </div>,
            <div key='emissionsfaktor' className={style.fields}>
                <div>
                    <label htmlFor='emissionsfaktor'>
                        Emissionsfaktor
                    </label>
                </div>
                <div>
                    <input
                        id='emissionsfaktor'
                        name='emissionsfaktor'
                        type='number'
                        value={values.emissionsfaktor || (values.emissionsfaktor === 0 ? 0 : null)}
                        onChange={(event: any) => this.onChange(event.target)}
                    />
                </div>
            </div>,
            <div key='quelle' className={style.fields}>
                <div>
                    <label htmlFor='quelle'>
                        Quelle / Datenbank
                    </label>
                </div>
                <div>
                    <input
                        id='quelle'
                        name='quelle'
                        type='text'
                        value={values.quelle}
                        onChange={(event: any) => this.onChange(event.target)}
                    />
                </div>
            </div>
        ];
    }

    renderText(): JSX.Element {
        let text: JSX.Element = null;

        switch ((this.props.entity || {}).entity) {
            case IDs.ENT_CO2_SCOPE3_ABFALL:
                text = <>
                    Sie möchten im E-Tool eine Abfallfraktion erfassen, die in dieser Liste (bisher) noch nicht verfügbar ist? Wir versuchen
                    gerne, die Liste für Sie zu vervollständigen. Füllen Sie dazu bitte folgende Informationen aus:<br />
                    &nbsp;→ Name / Verwendungszweck<br />
                    &nbsp;→ Emissionsfaktor (soweit bekannt)<br />
                    &nbsp;→ Quelle / Datenbank (soweit bekannt)<br />
                    <br />
                    Wir werden versuchen, die angefragte Abfallkategorie zeitnah zu ergänzen (sofern es bereits Daten zu diesen Materialien
                    gibt) und benachrichtigen Sie entsprechend.
                </>;
                break;
            case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
                text = <>
                    Sie nutzen im Betrieb Materialien, die in dieser Liste (bisher) noch nicht verfügbar sind? Wir versuchen gerne, die
                    Liste für Sie zu vervollständigen. Füllen Sie dazu bitte folgende Informationen aus:<br />
                    &nbsp;→ Name / Verwendungszweck<br />
                    &nbsp;→ Emissionsfaktor (soweit bekannt)<br />
                    &nbsp;→ Quelle / Datenbank (soweit bekannt)<br />
                    <br />
                    Wir werden versuchen, angefragte Materialien zeitnah zu ergänzen (sofern es bereits Daten zu diesen Materialien gibt)
                    und benachrichtigen Sie entsprechend.
                </>;
                break;
        }

        return (
            <div className={style.text}>
                {text}
            </div>
        );
    }

    renderValidation(key: string): JSX.Element {
        const validate: string = this.validateField(key);

        return validate
            ?
            <div
                className={formStyle.warnSign}
                style={{ margin: '-2px auto auto 4px', top: 'unset', right: 'unset' }}
                title={validate}
            >
                *
            </div>
            : null;
    }

    sendMail(): void {
        const username = this.apiService.getUsername();
        const values: any = this.FormData.getAllValues();
        const text = (
            `<html>` +
            `<body>` +
            `<b>Registrierung: </b>${username}<br />` +
            `<div><b>Name / Verwendungszweck: </b>${values.name || '-'}<br />` +
            `<b>Emissionsfaktor: </b>${values.emissionsfaktor || '-'}<br />` +
            `<b>Quelle / Datenbank: </b>${values.quelle || '-'}</div>` +
            `</body>` +
            `</html>`
        );
        // console.log('sendMail: ', values, this.absender, this.empfaenger, text);
        const absender = this.absender || 'Keine Mail-Adresse hinterlegt';
        if (this.empfaenger && values.name) {
            this.apiService.call(
                'sendMail',
                {
                    // Ohne emailTo bekommen Empfänger die Mail als BCC
                    // emailTo: [this.empfaenger],
                    emailTo: [this.empfaenger, 'michael.ring@wipscom.de'], // WKETOOL-108: Bugfix: E-Mail "Weitere Abfallkateogie" (vorübergehend)
                    // bcc: [this.empfaenger],
                    subject: this.subject,
                    text,
                    isHtml: true
                },
                (data: string, success: boolean) => {
                    // console.log(data, success);
                    if (success) {
                        alert('E-Mail wurde erfolgreich versendet.');
                    }
                },
                IDs.MOD_ETOOL_ADMIN
            );
        }
        this.props.onClose();
    }

    validateField(key: string): string {
        const name: string = (key || '').length
            ? key === 'name'
                ? 'Name / Verwendungszweck'
                : (key || '').replace(/^\w/, (name: string) => name.toUpperCase())
            : null;
        const value: number = this.FormData.getValue(key);

        return value === null
            ? `Bitte Feld "${name}" ausfüllen`
            : null;
    }
}
